import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import CaterForm from "../../components/cater/CaterForm";
import CaterTable from "../../components/cater/CaterTable";

function CaterPage() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [caters, setCaters] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCaters = async () => {
    try {
      const response = await fetch("/backend/cater/get_caters.php");
      const data = await response.json();

      if (data.success) {
        setCaters(data.caters || []);
      }
    } catch (error) {
      console.error("Error fetching caters:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCaters();
  }, []);

  const handleAddCater = async (formData) => {
    const response = await fetch("/backend/cater/add_cater.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (data.success) {
      fetchCaters();
    }

    return data;
  };

  const handleDeleteCater = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this cater?");
    if (!confirmDelete) return;

    try {
      const response = await fetch("/backend/cater/delete_cater.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ id })
      });

      const data = await response.json();

      if (data.success) {
        fetchCaters();
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (error) {
      alert("Unable to delete cater");
    }
  };

  return (
    <AdminLayout user={user}>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900">
            Cater Management
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Add and manage cater details from one place.
          </p>
        </div>

        <CaterForm onAddCater={handleAddCater} />

        {loading ? (
          <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 text-slate-500">
            Loading caters...
          </div>
        ) : (
          <CaterTable caters={caters} onDeleteCater={handleDeleteCater} />
        )}
      </div>
    </AdminLayout>
  );
}

export default CaterPage;